export const appName = 'Pilar Homes';
export const appDescription = 'Imóveis de luxo';
export const siteName = 'PilarHomes';
export const urlSouPilar = 'https://www.soupilar.com.br/';
export const mailSouPilar = 'contato@pilarhomes.com.br';
export const pilarFormattedPhone = '(11) 93502-5003';
export const pilarFormattedPhoneWhatsAppLink = `https://wa.me/55${pilarFormattedPhone.replace(/[^0-9]/g, '')}`;
export const pilarHomesInstagram = 'https://www.instagram.com.br/pilarhomes_';
